// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"a631b281","317":"505a88a6","787":"70bed51b"}[chunkId] + ".chunk.js";
};